export default {
  maxLevel: '{0} maximum level',
  queueEmpty: 'Queue empty',
  nextLevels: 'Next levels',
  bookNotFound: 'Find book upgrades for this feature by reaching the maximum level on certain upgrades',
  bookNotFoundVillage: 'Find book upgrades for this feature by reaching the maximum level on certain upgrades or buildings',

  keyset: {
    default: {
      notFound: 'No upgrades found',
      nextRequirement: 'Next upgrade unlocks at ',
      persistent: 'This upgrade is persistent and won\'t reset on prestige',
      bought: 'Upgrades bought'
    },
    building: {
      notFound: 'No buildings found',
      nextRequirement: 'Next building unlocks at ',
      persistent: 'This building is persistent and won\'t reset on prestige',
      bought: 'Buildings constructed'
    }
  },

  build: 'Build',
  subtype: {
    village_housing: 'This building counts as housing, increasing your global level for the first 25 built',
    village_workstation: 'This building counts as a workstation'
  },

  description: {
    mining_craftingStation: 'The crafting station allows you to consume ores to raise your pickaxe power and is essential to increase your damage',
    mining_compressor: 'The compressor allows you to increase the ore amount per slot for higher purity',
    mining_depthDweller: 'This gives access to the prestige option of the mine',
    mining_smeltery: 'This allows you to smelt ores and rare earth to create bars',
    mining_enhancingStation: 'This allows you to spend bars on unique pickaxe modifiers',
    mining_emberForge: 'Ember is gained on prestige and increases your smeltery speed',
    mining_stickyJar: 'Resin can be used for better crafting results, but takes a long time to generate',
    mining_premiumCraftingSlots: 'Upgrades one of your crafting slots to premium, which halves impurity above x1 and doubles purity',

    village_treasury: 'Tax rate causes your working villagers to consume food and pay taxes in return',
    village_church: 'This gives you access to the prestige option of the village',
    village_offeringPedestal: 'This allows you to sacrifice resources to permanently increase their capacity',
    village_court: 'Policies can be enabled to give bonuses in exchange for happiness, or vice versa',
    village_generator: 'Power increases your resource gain and pollution reduces happiness',
    village_darkCult: 'The religion policy allows you to prioritize resource or faith gain, at the expense of the other',
    village_pyramid: 'Explorers find a new resource over time. Hiring one requires 600 villagers, you may need the immigration policy to reach this!',
    village_radar: 'The scanning policy allows you to prioritize loot gain or quality, at the expense of the other',

    horde_purifier: 'Corrupted flesh is gained slowly over time and allows you to reduce corruption',

    farm_gardenGnome: 'Garden gnomes can be placed on the field for a chance to earn a new currency',
    farm_learning: 'Crop experience allows you to raise your global level',
    farm_wateringCan: 'Apply care to your plants for bigger harvests',
    farm_sprinkler: 'Sprinklers make crops grow faster in one row',
    farm_lectern: 'Lecterns increase crop experience in one column',
    farm_pinwheel: 'Pinwheels allow you to increase your rare drop chance',
    farm_potOfSand: 'Cactus increases crop experience, seeds can be obtained from big events',
    farm_flag: 'Flags increase yield based on positioning',
    farm_prettyFlowerPot: 'Cress increases rare drop chance',
    farm_premiumGardenGnome: 'Premium garden gnomes provide 1.5x gold chance',
    farm_premiumSprinkler: 'Premium sprinklers increase the grow speed and overgrow bonuses by 1.5x',
    farm_premiumLectern: 'Premium lecterns quadruple experience',
    farm_premiumPinwheel: 'Premium pinwheels provide 1.5x the drop chance bonus',
    farm_premiumFlag: 'Premium flags provide 1.5x the yield bonus',

    gallery_recycling: 'Conversion allows you to create new colors',
    gallery_redLuck: 'You\'ll need to upgrade luck first before you can find drums in packages',
    gallery_epiphany: 'Ideas allow you to spend limited inspiration on unique bonuses',
    gallery_auctionHouse: 'This gives you access to the prestige option of the gallery',
    gallery_paintDrumStorage: 'This lets you collect packages, which sometimes contain drums',
    gallery_emptyCanvas: 'Canvas lets you choose colors to slowly improve over time',
  },

  // Mining upgrades
  mining_damageUp: 'Damage +',
  mining_scrapGainUp: 'Scrap gain +',
  mining_scrapCapacityUp: 'Scrap capacity +',
  mining_aluminiumCache: 'Aluminium cache',
  mining_aluminiumHardening: 'Aluminium hardening',
  mining_craftingStation: 'Crafting station',
  mining_forge: 'Forge',
  mining_oreSlots: 'Ore slots',
  mining_compressor: 'Compressor',
  mining_copperCache: 'Copper cache',
  mining_aluminiumTanks: 'Aluminium tanks',
  mining_aluminiumAnvil: 'Aluminium anvil',
  mining_hullbreaker: 'Hullbreaker',
  mining_copperTanks: 'Copper tanks',
  mining_depthDweller: 'Depth Dweller',
  mining_aluminiumExpansion: 'Aluminium expansion',
  mining_refinery: 'Refinery',
  mining_copperExpansion: 'Copper expansion',
  mining_drillFuel: 'Drill fuel',
  mining_graniteHardening: 'Granite hardening',
  mining_oreShelf: 'Ore shelf',
  mining_heatShield: 'Heat shield',
  mining_tinCache: 'Tin cache',
  mining_furnace: 'Furnace',
  mining_smeltery: 'Smeltery',
  mining_bronzeCache: 'Bronze cache',
  mining_ironCache: 'Iron cache',
  mining_oreWashing: 'Ore washing',
  mining_ironExpansion: 'Iron expansion',
  mining_bronzeDrill: 'Bronze drill',
  mining_ironHardening: 'Iron hardening',
  mining_ironFilter: 'Iron filter',
  mining_masterForge: 'Master forge',
  mining_starForge: 'Star forge',
  mining_magnet: 'Magnet',
  mining_bronzeFilter: 'Bronze filter',
  mining_enhancingStation: 'Enhancing station',
  mining_enhancingHammer: 'Enhancing hammer',
  mining_warehouse: 'Warehouse',
  mining_corrosiveFumes: 'Corrosive fumes',
  mining_smeltingSalt: 'Smelting salt',
  mining_titaniumExpansion: 'Titanium expansion',
  mining_emberForge: 'Ember forge',
  mining_bronzeForge: 'Bronze forge',
  mining_stickyJar: 'Sticky jar',
  mining_acidVial: 'Acid vial',
  mining_titaniumCache: 'Titanium cache',
  mining_smallBombs: 'Small bombs',
  mining_giantForge: 'Giant forge',
  mining_gunpowder: 'Gunpowder',
  mining_nitricAcid: 'Nitric acid',
  mining_metalDetector: 'Metal detector',
  mining_nails: 'Nails',
  mining_recycling: 'Recycling',
  mining_scanning: 'Scanning',
  mining_largerSurface: 'Larger surface',
  mining_qualityWorkbench: 'Quality workbench',
  mining_titaniumForge: 'Titanium forge',
  mining_platinumExpansion: 'Platinum expansion',
  mining_hiddenStash: 'Hidden stash',
  mining_dynamite: 'Dynamite',
  mining_platinumCache: 'Platinum cache',
  mining_colossalOreStorage: 'Colossal ore storage',
  mining_smallOreStorage: 'Small ore storage',
  mining_titaniumBombs: 'Titanium bombs',
  mining_titaniumPickaxe: 'Titanium pickaxe',
  mining_undergroundRadar: 'Underground radar',
  mining_scrapShelf: 'Scrap shelf',
  mining_iridiumExpansion: 'Iridium expansion',
  mining_iridiumCache: 'Iridium cache',
  mining_stonecutter: 'Stonecutter',
  mining_iridiumTreetap: 'Iridium treetap',
  mining_deepCuts: 'Deep cuts',
  mining_iridiumBombs: 'Iridium bombs',
  mining_oreBag: 'Ore bag',
  mining_osmiumExpansion: 'Osmium expansion',
  mining_osmiumCache: 'Osmium cache',
  mining_darkBombs: 'Dark bombs',
  mining_colossalScrapStorage: 'Colossal scrap storage',
  mining_stoneDissolver: 'Stone dissolver',
  mining_leadExpansion: 'Lead expansion',

  mining_fumes: 'Fumes',
  mining_smallCrate: 'Small crate',
  mining_giantCrate: 'Giant crate',
  mining_morePressure: 'More pressure',
  mining_gasDweller: 'Gas dweller',
  mining_piston: 'Piston',
  mining_pollution: 'Pollution',
  mining_particleFilter: 'Particle filter',
  mining_hotAirBalloon: 'Hot air balloon',
  mining_conductor: 'Conductor',
  mining_vent: 'Vent',
  mining_urn: 'Urn',
  mining_lunarBlessing: 'Lunar blessing',
  mining_harvester: 'Harvester',
  mining_chalkboard: 'Chalkboard',
  mining_graphiteRod: 'Graphite rod',
  mining_minecart: 'Minecart',
  mining_moonstone: 'Moonstone',
  mining_nightVisionDevice: 'Night vision device',
  mining_enrichedCrystal: 'Enriched crystal',
  mining_matches: 'Matches',
  mining_smokeStabilizer: 'Smoke stabilizer',
  mining_elevator: 'Elevator',
  mining_shovel: 'Shovel',
  mining_smoker: 'Smoker',

  // Mining prestige upgrades
  mining_crystalBasics: 'Crystal basics',
  mining_crystalTips: 'Crystal tips',
  mining_crystalStorage: 'Crystal storage',
  mining_crystalDrill: 'Crystal drill',
  mining_crystalLens: 'Crystal lens',
  mining_crystalAluminiumStorage: 'Crystal aluminium storage',
  mining_crystalCopperStorage: 'Crystal copper storage',
  mining_crystalTinStorage: 'Crystal tin storage',
  mining_crystalIronStorage: 'Crystal iron storage',
  mining_crystalTitaniumStorage: 'Crystal titanium storage',
  mining_crystalPlatinumStorage: 'Crystal platinum storage',
  mining_crystalIridiumStorage: 'Crystal iridium storage',
  mining_crystalOsmiumStorage: 'Crystal osmium storage',
  mining_crystalLeadStorage: 'Crystal lead storage',
  mining_crystalDetector: 'Crystal detector',
  mining_crystalReplicator: 'Crystal replicator',
  mining_crystalPreservarium: 'Crystal preservarium',
  mining_crystalTools: 'Crystal tools',
  mining_crystalExplosives: 'Crystal explosives',
  mining_crystalRefinery: 'Crystal refinery',
  mining_crystalSmeltery: 'Crystal smeltery',
  mining_crystalEnhancer: 'Crystal enhancer',
  mining_crystalTreetap: 'Crystal treetap',
  mining_crystalSalt: 'Crystal salt',
  mining_crystalBottle: 'Crystal bottle',
  mining_crystalSafe: 'Crystal safe',
  mining_crystalEngine: 'Crystal engine',
  mining_crystalCoal: 'Crystal coal',
  mining_crystalTruck: 'Crystal truck',
  mining_crystalExpansion: 'Crystal expansion',
  mining_crystalTnt: 'Crystal TNT',
  mining_crystalBeacon: 'Crystal beacon',
  mining_crystalNiter: 'Crystal niter',
  mining_crystalBunker: 'Crystal bunker',
  mining_crystalOreBag: 'Crystal ore bag',

  mining_crystalSpikes: 'Crystal spikes',
  mining_crystalBooster: 'Crystal booster',
  mining_heliumReserves: 'Helium reserves',
  mining_crystalSmoke: 'Crystal smoke',
  mining_neonReserves: 'Neon reserves',
  mining_crystalFusion: 'Crystal fusion',
  mining_crystalConductor: 'Crystal conductor',
  mining_crystalRefuge: 'Crystal refuge',
  mining_crystalCave: 'Crystal cave',
  mining_crystalFilter: 'Crystal filter',
  mining_heliumWarehouse: 'Helium warehouse',
  mining_argonReserves: 'Argon reserves',
  mining_crystalTunnel: 'Crystal tunnel',
  mining_crystalDust: 'Crystal dust',
  mining_neonWarehouse: 'Neon warehouse',
  mining_crystalBombs: 'Crystal bombs',
  mining_crystalCollector: 'Crystal collector',
  mining_kryptonReserves: 'Krypton reserves',
  mining_crystalResort: 'Crystal resort',

  // Mining premium upgrades
  mining_moreDamage: 'More damage',
  mining_moreScrap: 'More scrap',
  mining_moreAluminium: 'More aluminium',
  mining_moreCopper: 'More copper',
  mining_moreTin: 'More tin',
  mining_moreIron: 'More iron',
  mining_moreTitanium: 'More titanium',
  mining_morePlatinum: 'More platinum',
  mining_moreIridium: 'More iridium',
  mining_moreOsmium: 'More osmium',
  mining_moreLead: 'More lead',
  mining_premiumCraftingSlots: 'Premium crafting slots',
  mining_moreGreenCrystal: 'More green crystals',
  mining_moreRareEarth: 'More rare earth',
  mining_fasterSmeltery: 'Faster smeltery',
  mining_moreResin: 'More resin',
  mining_moreHelium: 'More helium',
  mining_moreSmoke: 'More smoke',
  mining_moreNeon: 'More neon',
  mining_moreArgon: 'More argon',
  mining_moreKrypton: 'More krypton',

  // Village buildings
  village_campfire: 'Campfire',
  village_hut: 'Hut',
  village_storage: 'Storage',
  village_farm: 'Farm',
  village_plantation: 'Plantation',
  village_mine: 'Mine',
  village_communityCenter: 'Community center',
  village_treasury: 'Treasury',
  village_crane: 'Crane',
  village_forge: 'Forge',
  village_smallHouse: 'Small house',
  village_safe: 'Safe',
  village_well: 'Well',
  village_garden: 'Garden',
  village_townHall: 'Town hall',
  village_house: 'House',
  village_shed: 'Shed',
  village_tunnel: 'Tunnel',
  village_sawmill: 'Sawmill',
  village_library: 'Library',
  village_aquarium: 'Aquarium',
  village_glassBlowery: 'Glass manufactory',
  village_church: 'Church',
  village_knowledgeTower: 'Knowledge tower',
  village_miniatureSmith: 'Miniature smith',
  village_school: 'School',
  village_localGovernment: 'Local government',
  village_apartment: 'Apartment',
  village_temple: 'Temple',
  village_obelisk: 'Obelisk',
  village_offeringPedestal: 'Offering pedestal',
  village_theater: 'Theater',
  village_lumberjackHut: 'Lumberjack hut',
  village_deepMine: 'Deep mine',
  village_bigStorage: 'Big storage',
  village_luxuryHouse: 'Luxury house',
  village_lake: 'Lake',
  village_gemSawBlade: 'Gem saw blade',
  village_miniatureGlassblowery: 'Miniature glass manufactory',
  village_lostPages: 'Lost pages',
  village_playground: 'Playground',
  village_government: 'Government',
  village_modernHouse: 'Modern house',
  village_fountain: 'Fountain',
  village_laboratory: 'Laboratory',
  village_court: 'Court',
  village_greenhouse: 'Greenhouse',
  village_fullBasket: 'Full basket',
  village_storageHall: 'Storage hall',
  village_bioLab: 'Bio lab',
  village_festival: 'Festival',
  village_taxOffice: 'Tax office',
  village_cemetery: 'Cemetery',
  village_mosque: 'Mosque',
  village_waterTower: 'Water tower',
  village_outdoorPump: 'Outdoor pump',
  village_bankVault: 'Bank vault',
  village_steamEngine: 'Steam engine',
  village_mansion: 'Mansion',
  village_oilRig: 'Oil rig',
  village_generator: 'Generator',
  village_lighthouse: 'Lighthouse',
  village_lobby: 'Lobby',
  village_oilStorage: 'Oil storage',
  village_artGallery: 'Art gallery',
  village_excavator: 'Excavator',
  village_oilTruck: 'Oil truck',
  village_oldLibrary: 'Old library',
  village_immigrationOffice: 'Immigration office',
  village_marbleStatue: 'Marble statue',
  village_darkCult: 'Dark cult',
  village_slaughterhouse: 'Slaughterhouse',
  village_ecoCouncil: 'Eco council',
  village_treehouse: 'Treehouse',
  village_rainforest: 'Rainforest',
  village_luxuryStorage: 'Luxury storage',
  village_pyramid: 'Pyramid',
  village_trophyCase: 'Trophy case',
  village_antiquarian: 'Antiquarian',
  village_windTurbine: 'Wind turbine',
  village_radar: 'Radar',
  village_waterTurbine: 'Water turbine',
  village_solarPanel: 'Solar panel',

  // Village upgrades
  village_wallet: 'Wallet',
  village_resourceBag: 'Resource bag',
  village_metalBag: 'Metal bag',
  village_scythe: 'Scythe',
  village_hatchet: 'Hatchet',
  village_pickaxe: 'Pickaxe',
  village_wateringCan: 'Watering can',
  village_investment: 'Investment',
  village_basics: 'Basics',
  village_processing: 'Processing',
  village_pump: 'Pump',
  village_sand: 'Sand',
  village_book: 'Book',
  village_axe: 'Axe',
  village_bomb: 'Bomb',
  village_toll: 'Toll',
  village_fishingRod: 'Fishing rod',
  village_holyBook: 'Holy book',
  village_breakthrough: 'Breakthrough',
  village_modifiedPlants: 'Modified plants',
  village_dopamine: 'Dopamine',
  village_adrenaline: 'Adrenaline',
  village_sprinkler: 'Sprinkler',
  village_greed: 'Greed',
  village_ambition: 'Ambition',
  village_understanding: 'Understanding',
  village_curiosity: 'Curiosity',
  village_worship: 'Worship',
  village_bartering: 'Bartering',
  village_sparks: 'Sparks',

  village_cashRegister: 'Cash register',
  village_decoration: 'Decoration',
  village_plantFiberBin: 'Plant fiber bin',
  village_woodBin: 'Wood bin',
  village_stoneBin: 'Stone bin',
  village_metalBin: 'Metal bin',
  village_waterBin: 'Water bin',
  village_glassBin: 'Glass bin',
  village_hardwoodBin: 'Hardwood bin',
  village_gemBin: 'Gem bin',
  village_oilBin: 'Oil bin',
  village_marbleBin: 'Marble bin',

  // Village prestige upgrades
  village_arch: 'Ark',
  village_holyTree: 'Holy tree',
  village_holyGrass: 'Holy grass',
  village_holyRock: 'Holy rock',
  village_holyMetal: 'Holy metal',
  village_churchTax: 'Church tax',
  village_holyWater: 'Holy water',
  village_holyGlass: 'Holy glass',
  village_holyCrane: 'Holy crane',
  village_monk: 'Monk',
  village_holyPiggyBank: 'Holy piggy bank',
  village_deepWorship: 'Deep worship',
  village_cityPlanning: 'City planning',
  village_managers: 'Managers',
  village_warehouse: 'Warehouse',
  village_sandstone: 'Sandstone',
  village_holyForest: 'Holy forest',
  village_holyGem: 'Holy gem',
  village_deeperWorship: 'Deeper worship',
  village_holyLab: 'Holy lab',
  village_charity: 'Charity',
  village_holyOil: 'Holy oil',
  village_holyMarble: 'Holy marble',
  village_calmingSpeech: 'Calming speech',
  village_holyLoot: 'Holy loot',
  village_holyChisel: 'Holy chisel',

  village_hireArtisans: 'Hire artisans',
  village_hireExplorers: 'Hire explorers',
  village_recipeBook: 'Recipe book',
  village_hireWorkers: 'Hire workers',
  village_adCampaign: 'Ad campaign',
  village_hireAccountants: 'Hire accountants',
  village_hireGardeners: 'Hire gardeners',
  village_hireMiners: 'Hire miners',
  village_hireBartenders: 'Hire bartenders',
  village_hireExperts: 'Hire experts',

  // Village premium upgrades
  village_overtime: 'Overtime',
  village_goldenThrone: 'Golden throne',
  village_fasterBuilding: 'Faster building',
  village_moreFaith: 'More faith',
  village_moreWood: 'More wood',
  village_morePlantFiber: 'More plant fiber',
  village_moreStone: 'More stone',
  village_moreMetal: 'More metal',
  village_moreWater: 'More water',
  village_moreGlass: 'More glass',
  village_moreHardwood: 'More hardwood',
  village_moreGem: 'More gem',
  village_moreKnowledge: 'More knowledge',
  village_moreScience: 'More science',
  village_moreOil: 'More oil',
  village_moreMarble: 'More marble',

  // Horde upgrades
  horde_attack: 'Attack +',
  horde_health: 'Health +',
  horde_bones: 'Bones +',
  horde_training: 'Training',
  horde_resilience: 'Resilience',
  horde_boneBag: 'Bone bag',
  horde_rest: 'Rest',
  horde_anger: 'Anger',
  horde_monsterBag: 'Monster bag',
  horde_thickSkin: 'Thick skin',
  horde_luckyStrike: 'Lucky strike',
  horde_monsterSoup: 'Monster soup',
  horde_looting: 'Looting',
  horde_hoarding: 'Hoarding',
  horde_stabbingGuide: 'Stabbing guide',
  horde_dodgingGuide: 'Dodging guide',
  horde_plunderSecret: 'Plunder secret',
  horde_survivalGuide: 'Survival guide',
  horde_purifier: 'Purifier',
  horde_cleansingRitual: 'Cleansing ritual',
  horde_carving: 'Carving',
  horde_whitePaint: 'White paint',
  horde_grossBag: 'Gross bag',
  horde_targetDummy: 'Target dummy',
  horde_milestone: 'Milestone',
  horde_combatLesson: 'Combat lesson',
  horde_mysticalBag: 'Mystical bag',
  horde_unlimitedAnger: 'Unlimited anger',
  horde_strangePower: 'Strange power',
  horde_collector: 'Collector',
  horde_prepareTheSacrifice: 'Prepare the sacrifice',
  horde_mysticalPower: 'Mystical power',
  horde_redPaint: 'Red paint',
  horde_scalpel: 'Scalpel',
  horde_pocketKnife: 'Pocket knife',
  horde_protectiveVest: 'Protective vest',
  horde_luckyArtifact: 'Lucky artifact',
  horde_brownPaint: 'Brown paint',
  horde_grindstone: 'Grindstone',
  horde_strangeDetector: 'Strange detector',
  horde_weaponStorage: 'Weapon storage',
  horde_frostSpear: 'Frost spear',
  horde_lightningShield: 'Lightning shield',
  horde_waterBubble: 'Water bubble',

  horde_transfusion: 'Transfusion',
  horde_darkAttack: 'Dark attack',
  horde_darkHealth: 'Dark health',
  horde_harvest: 'Harvest',
  horde_protectiveShell: 'Protective shell',
  horde_bloodStorage: 'Blood storage',
  horde_secondChance: 'Second chance',
  horde_darkMilestone: 'Dark milestone',
  horde_endlessAnger: 'Endless anger',
  horde_fistFight: 'Fist fight',
  horde_syringe: 'Syringe',
  horde_bloodRitual: 'Blood ritual',
  horde_darkDummy: 'Dark dummy',
  horde_banishingRitual: 'Banishing ritual',
  horde_toothSpear: 'Tooth spear',
  horde_toothNecklace: 'Tooth necklace',
  horde_darkShield: 'Dark shield',

  // Horde prestige upgrades
  horde_balance: 'Balance',
  horde_wrath: 'Wrath',
  horde_peace: 'Peace',
  horde_milk: 'Milk',
  horde_butcher: 'Butcher',
  horde_beginnerLuck: 'Beginner luck',
  horde_advancedLuck: 'Advanced luck',
  horde_boneTrader: 'Bone trader',
  horde_soulCage: 'Soul cage',
  horde_victoryCelebration: 'Victory celebration',
  horde_offenseBook: 'Offense book',
  horde_defenseBook: 'Defense book',
  horde_candleCircle: 'Candle circle',
  horde_spoilsOfWar: 'Spoils of war',
  horde_ashCircle: 'Ash circle',
  horde_containmentChamber: 'Containment chamber',
  horde_mausoleum: 'Mausoleum',
  horde_lastWill: 'Last will',
  horde_combatStudies: 'Combat studies',
  horde_boneChamber: 'Bone chamber',
  horde_deepHatred: 'Deep hatred',
  horde_moreDummies: 'More dummies',
  horde_spiritLure: 'Spirit lure',
  horde_mysticalCondenser: 'Mystical condenser',
  horde_secretTraining: 'Secret training',
  horde_secretStorage: 'Secret storage',
  horde_pathfinder: 'Pathfinder',
  horde_exoskeleton: 'Exoskeleton',
  horde_essenceCollector: 'Essence collector',

  horde_precision: 'Precision',
  horde_resolve: 'Resolve',
  horde_determination: 'Determination',
  horde_education: 'Education',
  horde_bloodChamber: 'Blood chamber',
  horde_stoneSkin: 'Stone skin',
  horde_university: 'University',
  horde_discovery: 'Discovery',
  horde_innerFocus: 'Inner focus',
  horde_purge: 'Purge',
  horde_defensiveStance: 'Defensive stance',
  horde_chaosCrate: 'Chaos crate',
  horde_limitBreak: 'Limit break',
  horde_headhunter: 'Headhunter',
  horde_templeExploration: 'Temple exploration',

  // Horde crown upgrades
  horde_royalSword: 'Royal sword',
  horde_royalArmor: 'Royal armor',
  horde_royalStorage: 'Royal storage',
  horde_royalButcher: 'Royal butcher',
  horde_royalCrypt: 'Royal crypt',
  horde_royalSecret: 'Royal secret',
  horde_royalBlessing: 'Royal blessing',

  // Horde premium upgrades
  horde_morePower: 'More power',
  horde_moreBones: 'More bones',
  horde_moreMonsterParts: 'More monster parts',
  horde_moreSouls: 'More souls',
  horde_moreMastery: 'More mastery',
  horde_ancientPower: 'Ancient power',
  horde_ancientFortitude: 'Ancient fortitude',
  horde_ancientWealth: 'Ancient wealth',
  horde_ancientSpirit: 'Ancient spirit',
  horde_ancientSharpsight: 'Ancient sharpsight',
  horde_ancientHolding: 'Ancient holding',
  horde_ancientReaping: 'Ancient reaping',
  horde_ancientRemembrance: 'Ancient remembrance',
  horde_ancientExpertise: 'Ancient expertise',
  horde_ancientMystery: 'Ancient mystery',
  horde_ancientFreezing: 'Ancient freezing',
  horde_moreBlood: 'More blood',
  horde_moreCourage: 'More courage',
  horde_moreMonsterTeeth: 'More monster teeth',

  // Farm upgrades
  farm_seedBox: 'Seed box',
  farm_fertility: 'Fertility',
  farm_expansion: 'Expansion',
  farm_gardenGnome: 'Garden gnome',
  farm_overgrowth: 'Overgrowth',
  farm_learning: 'Learning',
  farm_wateringCan: 'Watering can',
  farm_manure: 'Manure',
  farm_seedBag: 'Seed bag',
  farm_groundSeeds: 'Seed grinder',
  farm_roastedSeeds: 'Roasted seeds',
  farm_rainBarrel: 'Rain barrel',
  farm_smallCrate: 'Small crate',
  farm_sprinkler: 'Sprinkler',
  farm_hayBales: 'Hay bales',
  farm_magnifyingGlass: 'Magnifying glass',
  farm_scarecrow: 'Scarecrow',
  farm_anthill: 'Anthill',
  farm_bugPowder: 'Bug powder',
  farm_shed: 'Shed',
  farm_gutter: 'Gutter',
  farm_lectern: 'Lectern',
  farm_pheromones: 'Pheromones',
  farm_perfume: 'Perfume',
  farm_mediumCrate: 'Medium crate',
  farm_stompedSeeds: 'Stomped seeds',
  farm_insectParadise: 'Insect paradise',
  farm_goldenTools: 'Golden tools',
  farm_butterflyWings: 'Butterfly wings',
  farm_fertileGround: 'Fertile ground',
  farm_pinwheel: 'Pinwheel',
  farm_pileOfPlants: 'Pile of plants',
  farm_compostBin: 'Compost bin',
  farm_mysticGround: 'Mystic ground',
  farm_fertilizerBag: 'Fertilizer bag',
  farm_bigCrate: 'Big crate',
  farm_artificialWebs: 'Artificial webs',
  farm_studyInsects: 'Study insects',
  farm_beehive: 'Beehive',
  farm_potOfSand: 'Pot of sand',
  farm_darkCorner: 'Dark corner',
  farm_carrotCake: 'Carrot cake',
  farm_flag: 'Flag',
  farm_honeyJar: 'Honey jar',
  farm_wormBait: 'Worm bait',
  farm_hayStorage: 'Hay storage',
  farm_shinySoil: 'Shiny soil',
  farm_fieldBlessing: 'Field blessing',
  farm_bigFertilizerBag: 'Big fertilizer bag',
  farm_smellyMud: 'Smelly mud',
  farm_openSesame: 'Open sesame',
  farm_prettyFlowerPot: 'Pretty flower pot',
  farm_flowerPainting: 'Flower painting',
  farm_plantEncyclopedia: 'Plant encyclopedia',
  farm_smallSeedBag: 'Small seed bag',
  farm_crateOfGrain: 'Crate of grain',
  farm_crateOfFlowers: 'Crate of flowers',
  farm_crateOfVegetables: 'Crate of vegetables',
  farm_crateOfBerries: 'Crate of berries',
  farm_ancientFlowerPot: 'Ancient flower pot',
  farm_trailOfSlime: 'Trail of slime',
  farm_bucketOfSnails: 'Bucket of snails',

  // Farm premium upgrades
  farm_biggerVegetables: 'Bigger vegetables',
  farm_biggerBerries: 'Bigger berries',
  farm_biggerGrain: 'Bigger grain',
  farm_biggerFlowers: 'Bigger flowers',
  farm_moreExperience: 'More experience',
  farm_premiumGardenGnome: 'Premium garden gnome',
  farm_premiumSprinkler: 'Premium sprinkler',
  farm_premiumLectern: 'Premium lectern',
  farm_premiumPinwheel: 'Premium pinwheel',
  farm_premiumFlag: 'Premium flag',

  // Gallery upgrades
  gallery_newStyle: 'New style',
  gallery_recycling: 'Recycling',
  gallery_redPower: 'Red power',
  gallery_redConversion: 'Red conversion',
  gallery_filters: 'Filters',
  gallery_orangePower: 'Orange power',
  gallery_redLuck: 'Red luck',
  gallery_epiphany: 'Epiphany',
  gallery_trashCan: 'Trash can',
  gallery_orangeConversion: 'Orange conversion',
  gallery_brush: 'Brush',
  gallery_auctionHouse: 'Auction house',
  gallery_yellowPower: 'Yellow power',
  gallery_orangeLuck: 'Orange luck',
  gallery_yellowConversion: 'Yellow conversion',
  gallery_paintDrumStorage: 'Paint drum storage',
  gallery_greenPower: 'Green power',
  gallery_yellowLuck: 'Yellow luck',
  gallery_greenConversion: 'Green conversion',
  gallery_redRage: 'Red rage',
  gallery_bluePower: 'Blue power',
  gallery_greenLuck: 'Green luck',
  gallery_blueConversion: 'Blue conversion',
  gallery_purplePower: 'Purple power',
  gallery_blueLuck: 'Blue luck',
  gallery_purpleConversion: 'Purple conversion',
  gallery_deepOrangePower: 'Red-orange power',
  gallery_purpleLuck: 'Purple luck',
  gallery_deepOrangeConversion: 'Red-orange conversion',
  gallery_emptyCanvas: 'Empty canvas',
  gallery_linen: 'Linen',
  gallery_amberPower: 'Golden power',
  gallery_deepOrangeLuck: 'Red-orange luck',
  gallery_amberConversion: 'Golden conversion',
  gallery_lightGreenPower: 'Light green power',
  gallery_amberLuck: 'Golden luck',
  gallery_lightGreenConversion: 'Light green conversion',
  gallery_tealPower: 'Teal power',
  gallery_lightGreenLuck: 'Light green luck',
  gallery_tealConversion: 'Teal conversion',
  gallery_lightBluePower: 'Light blue power',
  gallery_tealLuck: 'Teal luck',
  gallery_lightBlueConversion: 'Light blue conversion',
  gallery_pinkPower: 'Pink power',
  gallery_lightBlueLuck: 'Light blue luck',
  gallery_pinkConversion: 'Pink conversion',

  // Gallery shape upgrades
  gallery_bigCircle: 'Big circle',
  gallery_wellDrawnCircle: 'Well drawn circle',
  gallery_bigRectangle: 'Big rectangle',
  gallery_wellDrawnRectangle: 'Well drawn rectangle',
  gallery_creativity: 'Creativity',
  gallery_wellDrawnTriangle: 'Well drawn triangle',
  gallery_luckyStar: 'Lucky star',
  gallery_wellDrawnStar: 'Well drawn star',
  gallery_bigEllipse: 'Big ellipse',
  gallery_wellDrawnEllipse: 'Well drawn ellipse',
  gallery_bigHeart: 'Big heart',
  gallery_wellDrawnHeart: 'Well drawn heart',
  gallery_bigSquare: 'Big square',
  gallery_wellDrawnSquare: 'Well drawn square',
  gallery_bigOctagon: 'Big octagon',
  gallery_wellDrawnOctagon: 'Well drawn octagon',
  gallery_bigPentagon: 'Big pentagon',
  gallery_wellDrawnPentagon: 'Well drawn pentagon',
  gallery_bigHexagon: 'Big hexagon',
  gallery_wellDrawnHexagon: 'Well drawn hexagon',

  // Gallery prestige upgrades
  gallery_artAcademy: 'Art academy',
  gallery_redCrayon: 'Red crayon',
  gallery_rainbowJar: 'Rainbow jar',
  gallery_trashContainer: 'Trash container',
  gallery_orangeCrayon: 'Orange crayon',
  gallery_shapes: 'Shapes',
  gallery_forklift: 'Forklift',
  gallery_redCrate: 'Red crate',
  gallery_yellowCrayon: 'Yellow crayon',
  gallery_inspiringBooks: 'Inspiring books',
  gallery_expressDelivery: 'Express delivery',
  gallery_orangeCrate: 'Orange crate',
  gallery_biggerShapes: 'Bigger shapes',
  gallery_greenCrayon: 'Green crayon',
  gallery_sortingSystem: 'Sorting system',
  gallery_redTruck: 'Red truck',
  gallery_yellowCrate: 'Yellow crate',
  gallery_blueCrayon: 'Blue crayon',
  gallery_orangeTruck: 'Orange truck',
  gallery_greenCrate: 'Green crate',
  gallery_investment: 'Investment',
  gallery_purpleCrayon: 'Purple crayon',
  gallery_yellowTruck: 'Yellow truck',
  gallery_blueCrate: 'Blue crate',
  gallery_artClass: 'Art class',
  gallery_preparation: 'Preparation',
  gallery_deepOrangeCrayon: 'Red-orange crayon',
  gallery_greenTruck: 'Green truck',
  gallery_purpleCrate: 'Purple crate',
  gallery_amberCrayon: 'Golden crayon',
  gallery_truckConvoy: 'Truck convoy',
  gallery_lightGreenCrayon: 'Light green crayon',
  gallery_tealCrayon: 'Teal crayon',
  gallery_lightBlueCrayon: 'Light blue crayon',
  gallery_pinkCrayon: 'Pink crayon',

  // Gallery premium upgrades
  gallery_prettyColors: 'Pretty colors',
  gallery_prettyConverter: 'Pretty converter',
  gallery_prettyCash: 'Pretty cash',
  gallery_prettyShapes: 'Pretty shapes',
  gallery_prettyCanvas: 'Pretty canvas',
  gallery_prettyRed: 'Pretty red',
  gallery_prettyOrange: 'Pretty orange',
  gallery_prettyYellow: 'Pretty yellow',
  gallery_prettyGreen: 'Pretty green',
  gallery_prettyBlue: 'Pretty blue',
  gallery_prettyPurple: 'Pretty purple',
  'gallery_prettyDeep-orange': 'Pretty red-orange',
  gallery_prettyAmber: 'Pretty gold',
  'gallery_prettyLight-green': 'Pretty light green',
  gallery_prettyTeal: 'Pretty teal',
  'gallery_prettyLight-blue': 'Pretty light blue',
  gallery_prettyPink: 'Pretty pink',

  // Gem premium upgrades
  gem_topazBag: 'Topaz bag',

  // School premium upgrades
  school_student: 'Student',

  // Treasure premium upgrades
  treasure_moreSlots: 'More slots',
  treasure_moreFragments: 'More fragments',

  // Event upgrades
  event_firefly: 'Firefly',
  event_glowshroom: 'Glowshroom',
  event_glowfish: 'Glowfish',
  event_lantern: 'Lantern',
  event_campfire: 'Campfire',
  event_coral: 'Coral',
  event_jellyfish: 'Jellyfish',
  event_nightbloom: 'Nightbloom',
  event_neonlight: 'Neon light',
  event_sun: 'Sun',
  event_moonglow: 'Moonglow',
  event_burningFly: 'Burning fly',
  event_moreSpores: 'More spores',
  event_fins: 'Fins',
  event_lamppost: 'Lamppost',
  event_campfireStories: 'Campfire stories',
  event_sponge: 'Sponge',
  event_longerTentacles: 'Longer tentacles',
  event_nightTime: 'Night time',
  event_city: 'City',
  event_moreHelium: 'More helium',
  event_furiousFly: 'Furious fly',
  event_mycelium: 'Mycelium',
  event_gills: 'Gills',
  event_dimmer: 'Dimmer',
  event_marshmallows: 'Marshmallows',
  event_anemone: 'Anemone',
  event_toxin: 'Toxin',
  event_fullMoon: 'Full moon',
  event_ads: 'Ads',
  event_lessDistance: 'Less distance',
  event_fireflyEnlightened: 'Enlightened firefly',
  event_glowshroomEnlightened: 'Enlightened glowshroom',
  event_glowfishEnlightened: 'Enlightened glowfish',
  event_lanternEnlightened: 'Enlightened lantern',
  event_campfireEnlightened: 'Enlightened campfire',
  event_coralEnlightened: 'Enlightened coral',
  event_jellyfishEnlightened: 'Enlightened jellyfish',
  event_nightbloomEnlightened: 'Enlightened nightbloom',
  event_neonlightEnlightened: 'Enlightened neon light',
  event_sunEnlightened: 'Enlightened sun',

  event_colorfulSeedBag: 'Colorful seed bag',
  event_flowerPot: 'Flower pot',
  event_daisyProtection: 'Daisy protection',
  event_poppyProtection: 'Poppy protection',
  event_poppyFertilizer: 'Poppy fertilizer',
  event_irisProtection: 'Iris protection',
  event_irisFertilizer: 'Iris fertilizer',
  event_lilyProtection: 'Lily protection',
  event_lilyFertilizer: 'Lily fertilizer',
  event_orchidProtection: 'Orchid protection',
  event_orchidFertilizer: 'Orchid fertilizer',
  event_cornflowerProtection: 'Cornflower protection',
  event_cornflowerFertilizer: 'Cornflower fertilizer',
  event_greenhouse: 'Greenhouse',
  event_hugeVase: 'Huge vase',
  event_framedDaisy: 'Framed daisy',
  event_framedPoppy: 'Framed poppy',
  event_framedIris: 'Framed iris',
  event_framedLily: 'Framed lily',
  event_framedOrchid: 'Framed orchid',
  event_framedCornflower: 'Framed cornflower',

  event_juicyBait: 'Juicy bait',
  event_incubator: 'Incubator',
  event_fishWhistle: 'Fish whistle',
  event_pollution: 'Pollution',
  event_goldenHook: 'Golden hook',

  event_extraBuildingSlot: 'Extra building slot',
  event_doubleTime: 'Double time',
  event_tropicalBlessing: 'Tropical blessing',

  event_essenceCondenser: 'Essence condenser',
  event_luckyCharm: 'Lucky charm',
  event_biggerCauldron: 'Bigger cauldron',
  event_potionShelf: 'Potion shelf',
  event_ritualChalk: 'Ritual chalk',
  event_stabilizer: 'Stabilizer',
  event_pedestals: 'Pedestals',
  event_mystifier: 'Mystifier',
  event_bundle: 'Bundle',
  event_bagOfCandy: 'Bag of candy',

  event_pineTrees: 'Pine trees',
  event_woolHat: 'Wool hat',
  event_cookies: 'Cookies',
  event_attackBoost: 'Attack boost',
  event_healthBoost: 'Health boost',
};
